module.exports = __webpack_public_path__ + "static/media/Graphik-Semibold.997ca93d.ttf";